module.exports = __webpack_public_path__ + "static/product1_1-5207383b8135d78a8401d5053ed7567b.jpg";